<template>
  <div>
    <h3>Reverb Test</h3>
    <p v-if="message">📨 Nova mensagem: {{ message }}</p>
    <button @click="sendMessage">Disparar Mensagem</button>
  </div>
</template>

<script>
import Echo from '@/common/echo';
import ApiService from '../common/api.service';

export default {
  data() {
    return {
      message: '',
    };
  },
  mounted() {
    Echo.init(); // garante que está conectado
    window.Echo.private('test')
      .listen('.TestMessageSent', (e) => {
        this.message = e.message;
        console.log('Recebido via WebSocket:', e);
      });
  },
  methods: {
    async sendMessage() {
      try {
        const token = localStorage.getItem('token'); // ou use JwtService.getToken()
        await ApiService.post('broadcast/test', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (error) {
        console.error('Erro ao enviar:', error);
      }
    }
  }
};
</script>
